import { useState as I, useEffect as v, useCallback as a } from "react";
const B = (i, t, r) => {
  var c;
  const [E, s] = I({});
  v(() => {
    s({});
  }, [
    r
  ]);
  const l = a((e) => {
    const o = {};
    e.forEach((n) => {
      const h = n.target.dataset.breadcrumbid;
      n.isIntersecting ? o[h] = !0 : o[h] = !1;
    }), s((n) => ({
      ...n,
      ...o
    }));
  }, []);
  return v(() => {
    var o;
    if (!i)
      return () => null;
    const e = new IntersectionObserver(l, {
      root: t == null ? void 0 : t.current,
      threshold: 1
    });
    return Array.from((o = t == null ? void 0 : t.current) == null ? void 0 : o.children).filter((n) => n.classList.contains("ghostBreadcrumb")).forEach((n) => {
      e.observe(n);
    }), () => {
      e.disconnect();
    };
  }, [
    i,
    t,
    (c = t == null ? void 0 : t.current) == null ? void 0 : c.children,
    l,
    r
  ]), {
    visibleBreadcrumbs: E
  };
};
export {
  B as default
};
